import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';
import useRoleContext from 'contexts/role.context';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ExternalRiders from '.';
import { LOGISTICS_ROUTE_KEYS } from 'utils/constants';

const ExternalRiderHOCPage = () => {
  const { role } = useRoleContext();
  const navigate = useNavigate();

  const isAllowed = role === ENUM_ROLE.LOGISTICS_SUPER_ADMIN;

  useEffect(() => {
    if (!isAllowed) {
      const timer = setTimeout(() => {
        navigate(LOGISTICS_ROUTE_KEYS.OVERVIEW);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [isAllowed, navigate]);

  if (!isAllowed) {
    return (
      <h1 className='text-center font-semibold text-xl animate-bounce mt-20'>
        ⛔ Access Denied: You don’t have permission to view this page.
      </h1>
    );
  }

  return <ExternalRiders />;
};

export default ExternalRiderHOCPage;
